import React from "react";
import { ArrowLeft, FlaskConical } from "lucide-react";

export function Header({ view, context, onBackHome, language = "en" }) {
  const inTool = view !== "home";
  const nl = language === "nl";
  return (
    <header
      className="sticky top-0 z-40 bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/70 border-b border-black/10"
      data-testid="app-header"
    >
      <div className="max-w-6xl mx-auto w-full px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between gap-4">
        <button
          type="button"
          onClick={onBackHome}
          className="flex items-center gap-3 group focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[rgba(88,3,253,0.25)] rounded-xl pl-1 pr-2 py-1"
          data-testid="app-header-brand"
          aria-label={nl ? "SYNLAB startscherm" : "SYNLAB home"}
        >
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-[#5803FD] text-white shadow-[0_8px_20px_rgba(88,3,253,0.25)]">
            <FlaskConical className="h-5 w-5" aria-hidden />
          </span>
          <span className="flex flex-col leading-tight text-left">
            <span className="font-display text-base sm:text-lg font-semibold text-black">SYNLAB</span>
            <span className="hidden sm:block text-[11px] text-black/60">
              {nl ? "Synthetische gebruikers, ontwerpreflectie, datawijsheid" : "Synthetic Users, Design Reflection, Data Literacy"}
            </span>
          </span>
        </button>

        <div className="flex items-center gap-3">
          {inTool && context && (
            <span
              className="hidden md:inline-flex items-center text-xs text-black/55"
              data-testid="app-header-context"
            >
              {nl ? "Je bent in:" : "You are in:"} <span className="ml-1 text-black">{context.label}</span>
            </span>
          )}
          {inTool && (
            <button
              type="button"
              onClick={onBackHome}
              className="inline-flex items-center gap-1.5 text-sm text-black/70 hover:text-[#5803FD] underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgba(88,3,253,0.35)] rounded-md px-1 py-1"
              data-testid="app-header-back-home-button"
              aria-label={nl ? "Terug naar startscherm" : "Go back to homescreen"}
            >
              <ArrowLeft className="h-3.5 w-3.5" /> {nl ? "Home" : "Home"}
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
